import { Component, OnInit, Pipe, PipeTransform, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { DPAccountService } from './dp-accounts.service';
import { DPAccount } from './dp-account';
import { ActivatedRoute, Params } from '@angular/router';

import { DPProject } from './model/dp-project';
import { DPProjectService } from './dp-project.service';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { DPTimeSheet } from './model/dp-timesheet';
import { ToasterService } from 'angular2-toaster/src/toaster.service';


@Component({
  templateUrl: 'dp-project.component.html',

})
export class DPProjectComponent implements OnInit {
  projects: DPProject[];
  filteredProjects: DPProject[];
  selectedProject: DPProject;
  addingProject = false;
  errorResponse: any;
  navigated = false; // true if navigated here
  account: DPAccount;
  dialog: any;
  result: any;
  notificationTitle: any;
  notificationContent: any;
  notificationType: any;
  deleting = false;
  account_id: any;
  projectViewType = 'View All';
  monthlyHour: number;
  usedHours: number;
  endDate: string;
  remainingHour: number;
  unit: string;
  sponsoredHours: number;
  constructor(
    private toasterService: ToasterService,

    private router: Router,
    private _service: NotificationsService,
    private accountService: DPAccountService,
    private projectService: DPProjectService,
    private route: ActivatedRoute,
  ) { }


  public options = {
    timeOut: 5000,
    lastOnBottom: true,
    clickToClose: true,
    maxLength: 0,
    maxStack: 7,
    showProgressBar: true,
    pauseOnHover: true,
    preventDuplicates: false,
    preventLastDuplicates: 'visible',
    rtl: false,
    animate: 'scale',
    position: ['right', 'bottom']
  };


  createNotification() {
    switch (this.notificationType) {
        case 'success':
            //this._service.success(this.notificationTitle, this.notificationContent);
            this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
            break;
        case 'error':
            this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
            //this._service.error(this.notificationTitle, this.notificationContent);
            break;
        case 'info':
            this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
            //this._service.info(this.notificationTitle, this.notificationContent);
            break;
    }
}

  calculateHours(timesheets: DPTimeSheet[]) {
    let currentBillableHours = 0;
    timesheets.forEach(timesheet => timesheet.billable == 1 ? currentBillableHours += +timesheet.hours : null);
    return currentBillableHours;
  }


  getProjectsByAccountId(account_id: number) {
    return this.projectService
      .getProjectsByAccountId(account_id)
      .then(res => {
        this.projects = res.projects;
        this.projects.sort((a, b) => new Date(b.start_date).getTime() - new Date(a.start_date).getTime());
        this.endDate = res.end_date;
        this.remainingHour = res.remaining_hours;
        this.monthlyHour = res.agreed_hours;
        this.usedHours = res.used_hours;
        this.sponsoredHours = res.sponsored_hours;
        this.unit = res.unit;
        this.clickViewType(event);

      }
      )
      .catch(error => {
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        const jsonErrorBody = JSON.parse(error._body);
        this.notificationContent = jsonErrorBody.error.message;
        this.createNotification();
      });
  }


  ngOnInit() {
    this.route.params.forEach((params: Params) => {
      this.account_id = +params['account_id'];
      localStorage.setItem('accountId', params['account_id']);

    });
    this.navigated = true;
    this.accountService.getAccount(this.account_id)
      .then(account => this.account = account);
    this.getProjectsByAccountId(this.account_id);
  }
  goBack() {
    if (this.navigated) {
      event.stopPropagation();
      this.router.navigate(['/demandportal/customer/account', this.account.customer.customer_id]);

    }
  }

  onSelect(project: DPProject) {
    this.selectedProject = project;
    this.addingProject = false;
  }

  gotoDetail(project: DPProject) {
    this.router.navigate(['/demandportal/customer/account/projects/projectdetail', project.project_id]);
  }

  selectCreateProject() {
    this.router.navigate(['/demandportal/customer/account/projects/projectcreate', this.account.account_id]);
  }

  createTimeSheet(project: DPProject) {
    this.router.navigate(['/demandportal/customer/account/projects/timesheetcreate', project.project_id]);
  }


  clickViewType(event: any) {
    if (this.projectViewType == 'View All') {
      this.filteredProjects = this.projects;
    } else if (this.projectViewType == 'View Active') {
      this.filteredProjects = this.projects.filter(c => c.status == 'active');
    }
    else if (this.projectViewType == 'View On Hold') {
      this.filteredProjects = this.projects.filter(c => c.status == 'onhold');
    }
    else if (this.projectViewType == 'View Cancelled') {
      this.filteredProjects = this.projects.filter(c => c.status == 'cancelled');
    }
    else {
      this.filteredProjects = this.projects.filter(c => c.status == 'completed');
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/portalv1/dp-project.component.ts